import BigPicture from 'bigpicture'; // BigPicture lightbox for popout video players and property image galleries.

export function listingVideoInit() {
	const listingVideos = document.querySelectorAll('.listing-video');

	listingVideos.forEach((item) =>
		item.addEventListener('click', function (e) {
			console.log(item.dataset);
			BigPicture({
				el: item,
				ytSrc: item.dataset.ytsrc,
			});
		}),
	);
}
